import { render } from "./HelpMenu.vue?vue&type=template&id=7e2b589d&scoped=true"
import script from "./HelpMenu.vue?vue&type=script&lang=js"
export * from "./HelpMenu.vue?vue&type=script&lang=js"

import "./HelpMenu.vue?vue&type=style&index=0&id=7e2b589d&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2b589d"]])

export default __exports__